import React, { useEffect, useState } from 'react'
import CMS from '../../../components/cms/CMS'
import PageBanner from '../../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { SortableList } from '../../../components/form/SortedBy'
import { fetchProductGet } from '../../../redux/slices/productGetSlice'
import { fetchShowcaseGetAllByProduct } from '../../../redux/slices/showcaseGetAllByProductSlice'
import { fetchShowcaseDelete } from '../../../redux/slices/showcaseDeleteSlice'
import { fetchShowcaseSort } from '../../../redux/slices/showcaseSortSlice'
import CrudShowcase from './CrudShowcase'

const ShowcasesPage = () => {
    const [modal, setModal] = useState(false)
    const [changed, setChanged] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const product = useSelector((state) => state.productGet.data)
    const lang = useSelector((state) => state.lang.lang)
    const status = useSelector((state) => state.showcaseGetAllByProduct.status)
    const showcasesByProduct = useSelector((state) => state.showcaseGetAllByProduct.data)
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const { id } = useParams()

    const getData = async () => {
        await dispatch(fetchShowcaseGetAllByProduct({ id: id }))
        await dispatch(fetchProductGet({ id: id }))
    }

    const deleteData = async (id) => {
        await dispatch(fetchShowcaseDelete({ id: id }))
        getData()
    }

    const handleSorted = (newList) => {
        showcasesByProduct.forEach(async (oldItem, oldIndex) => {
            const newIndex = newList.findIndex(item => item.id === oldItem.id);
            await dispatch(fetchShowcaseSort({ id: oldItem.id, sort: newIndex + 1 }))
            setChanged(true)
            getData()
        });
    };

    useEffect(() => {
        getData()
    }, [dispatch, id, changed])

    return (
        <CMS>
            {
                product ? <>
                    <PageBanner
                        modal={modal}
                        setModal={setModal}
                        title={product?.title[lang]}
                        description={t("showcase_management_desc")}
                        buttonText={t("add_showcase")}
                    />

                    {status === "succeeded" ?
                        <SortableList
                            setModal={setModal}
                            list={showcasesByProduct ? [...showcasesByProduct].sort((a, b) => a.sort - b.sort) : []}
                            onChange={handleSorted}
                            setChanged={setChanged}
                            deleteData={deleteData}
                            setSelectedItem={setSelectedItem}
                        /> : null
                    }

                    <CrudShowcase
                        showMenu={modal}
                        setShowMenu={setModal}
                        setChanged={setChanged}
                        setSelectedItem={setSelectedItem}
                        lang={lang}
                        id={id}
                        selectedItem={selectedItem}
                        t={t}
                    />
                </> : null
            }
        </CMS>
    )
}

export default ShowcasesPage
